import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=0d42c5bb&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d42c5bb')) {
      api.createRecord('0d42c5bb', component.options)
    } else {
      api.reload('0d42c5bb', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=0d42c5bb&", function () {
      api.rerender('0d42c5bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2COH0VANCSZxP/JS/imageCarousel.vue"
export default component.exports